import { Modal } from "react-bootstrap"
import AppModal from "../../Common/AppModal"

type Props = {
    info: string[]
    setInfo: React.Dispatch<React.SetStateAction<string[]>>
}
const Info: React.FC<Props> = (props) => {

    const dismiss = (msg: string) => {
        props.setInfo(props.info.filter(m => m !== msg))
    }

    return (
        <>
            {props.info.map((msg, i) => <AppModal key={i} name={`info_{i}`} title={"Information"} onClose={() => dismiss(msg)} alwaysShow>
                <Modal.Body className="p-2">
                    {msg}
                </Modal.Body>
            </AppModal>)}
        </>
    )
}

export default Info